import Instrument from "shared/games/instruments/Instrument";
import { Looop, loopAudioFiles } from "shared/games/Looop";
import { audioCtx } from "util/audioContext";
import { LooopPlayerSyncParams, PartialLooopPlayerSyncParams } from "./types";
import { InstrumentPlayer } from "../InstrumentPlayer/InstrumentPlayer";

interface SourcesNeededConfig {
  instruments?: Instrument[];
  audioFiles?: typeof loopAudioFiles[number][];
}

export class LooopPlayer {
  private looop: Looop;
  private sourcesNeeded: SourcesNeededConfig;
  private allPlayers: InstrumentPlayer[] = [];
  private players: { [instrument: string]: InstrumentPlayer } = {};
  private defaultSyncParams: PartialLooopPlayerSyncParams = {};

  constructor(
    looop: Looop,
    sourcesNeeded: SourcesNeededConfig = {},
    defaultSyncParams: PartialLooopPlayerSyncParams = {}
  ) {
    this.looop = looop;
    this.sourcesNeeded = sourcesNeeded;
    this.defaultSyncParams = defaultSyncParams;
  }

  public load = async () => {
    const audioFiles = this.sourcesNeeded.audioFiles ?? [...loopAudioFiles];
    const instruments =
      this.sourcesNeeded.instruments ??
      Object.values(this.looop.instruments).map(({ instrument }) => instrument);

    instruments.forEach((instrument) => {
      const defaultSyncParams =
        this.defaultSyncParams?.[instrument]?.audioFiles;

      const player = new InstrumentPlayer(
        this.looop.instruments[instrument],
        this.looop,
        audioFiles,
        defaultSyncParams
      );

      this.players[instrument] = player;
      this.allPlayers.push(player);
    });

    console.log("Loading...");

    await Promise.all(this.allPlayers.map((player) => player.load()));

    console.log("Completed loading");
  };

  public start = () => {
    const startTime = audioCtx().currentTime + 0.2;
    this.allPlayers.forEach((player) => player.start(startTime));
  };

  public stop = () => {
    const endTime = audioCtx().currentTime + 0.2;
    this.allPlayers.forEach((player) => player.stop(endTime));
  };

  public dispose = () => {
    this.allPlayers.forEach((player) => player.dispose());
  };

  public sync = (params: PartialLooopPlayerSyncParams) => {
    const time = audioCtx().currentTime + 0.4;

    Object.values(params).forEach(({ instrument, audioFiles }) => {
      const player = this.players[instrument];

      if (!player) {
        console.log("no player found for likely wasn't loaded", instrument);

        return;
      }

      player.sync(audioFiles, time);
    });
  };
}
